import React, { createContext, useCallback, useMemo, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const DropdownContext = createContext({ focusDate: undefined, onDayKeyDown: () => {} });

export const DropdownProvider = ({ children }) => {
  const [focusDate, setFocusDate] = useState();
  const [focusOn, setFocusOn] = useState('day');
  const onDayKeyDown = useCallback((e, prevMomentDate) => {
    let newDate;
    const prevDate = prevMomentDate.clone();
    e.preventDefault();
    switch (e.key) {
      case 'ArrowLeft':
        newDate = prevDate.subtract(1, 'day');
        break;
      case 'ArrowRight':
        newDate = prevDate.add(1, 'day');
        break;
      case 'ArrowUp':
        newDate = prevDate.subtract(1, 'week');
        break;
      case 'ArrowDown':
        newDate = prevDate.add(1, 'week');
        break;
      case 'Tab': {
        if (e.shiftKey) {
          setFocusOn('nav');
        } else {
          setFocusOn('buttons');
        }
        return;
      }
      default:
        return;
    }
    setFocusOn('day');
    setFocusDate(newDate);
  }, []);

  const value = useMemo(
    () => ({
      focusDate,
      focusOn,
      onDayKeyDown,
      setFocusOn,
    }),
    [focusDate, onDayKeyDown, focusOn]
  );

  return <DropdownContext.Provider value={value}>{children}</DropdownContext.Provider>;
};

DropdownProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useDropdownContext = () => useContext(DropdownContext);

export default DropdownContext;
